var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9858 17.5147C13.9858 11.1555 19.1412 6.00012 25.5004 6.00012C31.8596 6.00012 37.015 11.1555 37.015 17.5147",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1056 33.6353V38.395C30.1056 40.9388 28.0434 43.001 25.4996 43.001C22.9557 43.001 20.8936 40.9388 20.8936 38.395V33.6353",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9858 17.5147C13.9858 24.4233 20.8944 26.7259 20.8944 33.6353",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0141 17.5147C37.0141 24.4233 30.1055 26.7259 30.1055 33.6353",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5005 12.9087L27.1929 15.1852L29.8808 16.0905L28.2379 18.4034L28.2075 21.2398L25.5005 20.3918L22.7935 21.2398L22.7631 18.4034L21.1201 16.0905L23.808 15.1852L25.5005 12.9087Z",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5911 38.3942H32.4082",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5911 33.6353H32.4082",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.5147H9.37982",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 17.5147H41.6201",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54468 26.7258L11.5391 25.5741",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4554 8.30353L39.4609 9.45525",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54468 8.30353L11.5391 9.45525",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4554 26.7258L39.4609 25.5741",
    strokeWidth: 1.71425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspiration);
export default __webpack_public_path__ + "9f8d814b3c52542e1c466748ea33ccea.svg";
export { ForwardRef as ReactComponent };